import { v4 as uuidv4 } from "uuid";
import * as $ from "jquery";
import DataTable from "datatables.net";
import CryptoJS from "crypto-js";
import { APP_ENV } from "@/APP_ENV";

export function parseJSON(json) {
  if (typeof json === "object") return json;
  try {
    return JSON.parse(json);
  } catch (e) {
    console.log("Error parsing JSON:", e);
    return json;
  }
}

export function uniqueObjectArray(arrayObject, key1, key2) {
  const tmp = {};
  arrayObject.forEach(item => {
    tmp[item[key1] || item[key2]] = item;
  });
  return Object.values(tmp);
}

export function flattenTreeData(treeData, parentId, rootId, rootName) {
  let result = [];
  treeData.forEach(item => {
    result.push({
      ...item,
      parentId,
      rootId: rootId || item.key,
      rootName: rootName || item.name || item.title
    });
    if (item.children) {
      result = result.concat(
        flattenTreeData(item.children, item.key, item.rootId, item.rootName)
      );
    }
  });
  return result;
}

function flattenToTree(data) {
  // 创建一个映射以便快速查找节点
  const map = {};
  const result = [];

  // 首先将所有节点存入映射表
  data.forEach(item => {
    map[item.id] = { ...item, children: [] };
  });

  // 遍历所有节点，将子节点放入父节点的children中
  data.forEach(item => {
    if (item.parentId) {
      const parent = map[item.parentId];
      if (parent) {
        parent.children.push(map[item.id]);
      }
    } else {
      // 没有parentId的是根节点
      result.push(map[item.id]);
    }
  });

  return result;
}

export function mergeTreeData(list, key, children) {
  return list.map(node => {
    if (node.key === key) {
      return {
        ...node,
        children: [...(node.children || []), ...children]
      };
    }
    if (node.children) {
      return {
        ...node,
        children: mergeTreeData(node.children, key, children)
      };
    }
    return node;
  });
}

export function mergeTreeDataByGroup(treeData, toMergeFlattenData) {
  const expandKeys = new Set();
  const flattenData = flattenTreeData(treeData);
  const newData = [];
  function getExpandKeys(node) {
    expandKeys.add(node.id);
    node = flattenData.find(item => item.id === node.parentId);
    if (node) {
      expandKeys.add(node.id);
      if (node.parentId) {
        getExpandKeys(node);
      }
    }
  }

  flattenData.forEach(node => {
    const dataInGroup = toMergeFlattenData.filter(
      item => item.parentId === node.id
    );
    if (dataInGroup.length > 0) {
      getExpandKeys(node);
      newData.push(...dataInGroup);
    }
  });

  return {
    result: flattenToTree([...flattenData, ...newData]),
    expandKeys: Array.from(expandKeys)
  };
}

export function downloadBlob(data, fileName, type) {
  let blob = new Blob([data], {
    type: type || "application/octet-stream"
  });

  // Create a link (a tag) to trigger the download
  let url = window.URL.createObjectURL(blob);
  let a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = fileName; // Set the desired file name and extension
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
}

export function uuid(...args) {
  return uuidv4(...args);
}

var _pluck = function (a, prop, prop2) {
  var out = [];
  var i = 0,
    ien = a.length;

  // Could have the test in the loop for slightly smaller code, but speed
  // is essential here
  if (prop2 !== undefined) {
    for (; i < ien; i++) {
      if (a[i] && a[i][prop]) {
        out.push(a[i][prop][prop2]);
      }
    }
  } else {
    for (; i < ien; i++) {
      if (a[i]) {
        out.push(a[i][prop]);
      }
    }
  }
  return out;
};

function _fnSortFlatten(settings) {
  var i,
    iLen,
    k,
    kLen,
    aSort = [],
    aiOrig = [],
    aoColumns = settings.aoColumns,
    aDataSort,
    iCol,
    sType,
    srcCol,
    fixed = settings.aaSortingFixed,
    fixedObj = $.isPlainObject(fixed),
    nestedSort = [],
    add = function (a) {
      if (a.length && !Array.isArray(a[0])) {
        // 1D array
        nestedSort.push(a);
      } else {
        // 2D array
        $.merge(nestedSort, a);
      }
    };

  // Build the sort array, with pre-fix and post-fix options if they have been
  // specified
  if (Array.isArray(fixed)) {
    add(fixed);
  }
  if (fixedObj && fixed.pre) {
    add(fixed.pre);
  }
  add(settings.aaSorting);
  if (fixedObj && fixed.post) {
    add(fixed.post);
  }
  for (i = 0; i < nestedSort.length; i++) {
    srcCol = nestedSort[i][0];
    aDataSort = aoColumns[srcCol].aDataSort;
    for (k = 0, kLen = aDataSort.length; k < kLen; k++) {
      iCol = aDataSort[k];
      sType = aoColumns[iCol].sType || "string";
      if (nestedSort[i]._idx === undefined) {
        nestedSort[i]._idx = $.inArray(
          nestedSort[i][1],
          aoColumns[iCol].asSorting
        );
      }
      aSort.push({
        src: srcCol,
        col: iCol,
        dir: nestedSort[i][1],
        index: nestedSort[i]._idx,
        type: sType,
        formatter: DataTable.ext.type.order[sType + "-pre"]
      });
    }
  }
  return aSort;
}

export function fnAjaxParameters(settings) {
  var columns = settings.aoColumns,
    columnCount = columns.length,
    features = settings.oFeatures,
    preSearch = settings.oPreviousSearch,
    preColSearch = settings.aoPreSearchCols,
    i,
    data = [],
    dataProp,
    column,
    columnSearch,
    sort = _fnSortFlatten(settings),
    displayStart = settings._iDisplayStart,
    displayLength =
      features.bPaginate !== false ? settings._iDisplayLength : -1;
  var param = function (name, value) {
    data.push({
      name: name,
      value: value
    });
  };

  // DataTables 1.9- compatible method
  param("sEcho", settings.iDraw);
  param("iColumns", columnCount);
  param("sColumns", _pluck(columns, "sName").join(","));
  param("iDisplayStart", displayStart);
  param("iDisplayLength", displayLength);

  // DataTables 1.10+ method
  var d = {
    draw: settings.iDraw,
    columns: [],
    order: [],
    start: displayStart,
    length: displayLength,
    search: {
      value: preSearch.sSearch,
      regex: preSearch.bRegex
    }
  };
  for (i = 0; i < columnCount; i++) {
    column = columns[i];
    columnSearch = preColSearch[i];
    dataProp = typeof column.mData == "function" ? "function" : column.mData;
    d.columns.push({
      data: dataProp,
      name: column.sName,
      searchable: column.bSearchable,
      orderable: column.bSortable,
      search: {
        value: columnSearch.sSearch,
        regex: columnSearch.bRegex
      }
    });
    param("mDataProp_" + i, dataProp);
    if (features.bFilter) {
      param("sSearch_" + i, columnSearch.sSearch);
      param("bRegex_" + i, columnSearch.bRegex);
      param("bSearchable_" + i, column.bSearchable);
    }
    if (features.bSort) {
      param("bSortable_" + i, column.bSortable);
    }
  }
  if (features.bFilter) {
    param("sSearch", preSearch.sSearch);
    param("bRegex", preSearch.bRegex);
  }
  if (features.bSort) {
    $.each(sort, function (i, val) {
      d.order.push({
        column: val.col,
        dir: val.dir
      });
      param("iSortCol_" + i, val.col);
      param("sSortDir_" + i, val.dir);
    });
    param("iSortingCols", sort.length);
  }

  // If the legacy.ajax parameter is null, then we automatically decide which
  // form to use, based on sAjaxSource
  var legacy = DataTable.ext.legacy.ajax;
  if (legacy === null) {
    return settings.sAjaxSource ? data : d;
  }

  // Otherwise, if legacy has been specified then we use that to decide on the
  // form
  return legacy ? data : d;
}

/**
 * 将秒数转换为 DD:HH:MM:SS 格式的字符串
 * @param {number} totalSeconds - 输入的总秒数
 * @returns {string} - 转换后的 DD:HH:MM:SS 格式的字符串
 */
export function formatSeconds(totalMinutes) {
  let totalSeconds = totalMinutes * 60;
  // 计算天数
  const days = Math.floor(totalSeconds / (24 * 3600));
  totalSeconds %= 24 * 3600;

  // 计算小时数
  const hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;

  // 计算分钟数
  const minutes = Math.floor(totalSeconds / 60);

  // 剩余的秒数
  // const seconds = totalSeconds % 60;

  // 格式化为 DD:HH:MM 的字符串
  const formattedString = `${String(days).padStart(2, "0")}:${String(
    hours
  ).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;

  return formattedString;
}

export async function fakePromise(duration = 100) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, duration);
  });
}

export function generateIntlHash(content) {
  // Generate SHA-512 hash
  const hash = CryptoJS.SHA512(content).toString(CryptoJS.enc.Base64);
  // Extract the first 6 characters
  return hash.substring(0, 6);
}

export function getTwinsDesiredOrReportedByLastUpdated(properties, name) {
  const desiredMetadata = properties.desired.$metadata.custom_properties ?? {};
  const customProperties = properties.desired.custom_properties ?? {};
  const reportedMetadata = properties.reported.$metadata;
  const reportedProperties = properties.reported ?? {};
  const desiredProperties = properties.desired ?? {};

  if (name === "screen_rotation") {
    if (!desiredMetadata["screen_rotation"])
      desiredMetadata["screen_rotation"] = desiredMetadata["rotation"];
    if (!customProperties["screen_rotation"])
      customProperties["screen_rotation"] = customProperties["rotation"];
  }

  const reportedValue = reportedProperties[name];
  const desiredValue = customProperties[name];

  if (reportedValue === undefined && desiredValue === undefined) {
    return desiredProperties[name];
  }

  if (reportedValue === undefined) {
    return desiredValue;
  }

  if (desiredValue !== undefined) {
    if (
      new Date(desiredMetadata[name].$lastUpdated).getTime() <
      new Date(reportedMetadata[name].$lastUpdated).getTime()
    ) {
      return reportedValue;
    }
    return desiredValue;
  }

  return undefined;
}

export function renderAlarmPolicy(data, row) {
  if (data === "Peripheral Monitor") {
    return `${data} ${row.alarmPolicyOperator} ${
      JSON.parse(row.alarmPolicyExt || "{}").name
    }`;
  }
  if (data === "App Crash Detection") {
    return `${data} ${row.alarmPolicyOperator} ${
      JSON.parse(row.alarmPolicyExt || "{}").app
    }`;
  }
  return `${data} ${row.alarmPolicyOperator} ${row.alarmPolicyValue}${row.alarmPolicyUnit}`;
}

/**
 * 将秒数转换为 HH:MM:SS 格式的字符串
 * @param {number | string} seconds - 输入的总秒数
 * @returns {string} - 转换后的 HH:MM:SS 格式的字符串
 */
export function formatSecondsToTime(seconds) {
  const roundedSeconds = Math.round(seconds);

  const hours = Math.floor(roundedSeconds / 3600);
  const minutes = Math.floor((roundedSeconds % 3600) / 60);
  const remainingSeconds = roundedSeconds % 60;

  const pad = num => num.toString().padStart(2, "0");
  return `${pad(hours)}:${pad(minutes)}:${pad(remainingSeconds)}`;
}

// 常见二级公共后缀（只列举常用的，可自行扩展）
// prettier-ignore
const secondLevelTlds = new Set([
  // 中国
  "com.cn", "net.cn", "org.cn", "gov.cn", "edu.cn", "mil.cn",

  // 香港 / 台湾 / 新加坡
  "com.hk", "edu.hk", "org.hk", "idv.hk",
  "com.tw", "edu.tw", "org.tw", "net.tw",
  "com.sg", "edu.sg", "gov.sg", "org.sg",

  // 日本
  "co.jp", "ac.jp", "or.jp", "go.jp", "ne.jp",

  // 英国
  "co.uk", "org.uk", "gov.uk", "ac.uk", "ltd.uk", "plc.uk",

  // 澳大利亚
  "com.au", "net.au", "org.au", "edu.au", "gov.au",

  // 韩国
  "co.kr", "or.kr", "go.kr", "ac.kr", "ne.kr"
]);

export function getSiteMainDomain() {
  const commonDomain = APP_ENV.REACT_APP_COMMON_DOMAIN;
  if (commonDomain) {
    return commonDomain;
  }

  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  if (parts.length <= 2) return hostname; // 已经是根域名

  const lastTwo = parts.slice(-2).join(".");
  const lastThree = parts.slice(-3).join(".");

  // 如果最后两段是二级后缀，则主域名应包含最后三段
  if (secondLevelTlds.has(lastTwo)) {
    return lastThree;
  }
  return lastTwo;
}

export function isCNDomain() {
  const isCN = APP_ENV.REACT_APP_CN;
  if (isCN) {
    return isCN === "true" || isCN === true;
  }
  return window.location.hostname.endsWith(".cn");
}

export function getPlatformDomain() {
  const { hostname, protocol } = window.location;
  if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_UNAUTH_REDIRECT_URL;
  }
  const com = hostname.split(".").slice(1).join(".");
  return `${protocol}//${APP_ENV.REACT_APP_PLATFORM_PREFIX}.${com}`;
}

export function getDayStartTime() {
  const date = new Date()
  date.setHours(0)
  date.setMinutes(0)
  date.setSeconds(0)
  return date.valueOf()
}

export function getDayEndTime() {
  const date = new Date()
  date.setHours(23)
  date.setMinutes(59)
  date.setSeconds(59)
  return date.valueOf()
}